import React from 'react'
import { css, CSSObject, SerializedStyles } from '@emotion/core'
import { RadioButtonSquare } from '../atoms/radio-button-square'

type Props<T extends string> = {
  value: T | undefined
  name: string
  items: Array<{ label: string; value: T }>
  onChange: (value: T) => void
  style?: CSSObject | SerializedStyles
  itemStyle?: CSSObject | SerializedStyles
}

export const RadioSquareGroupField = <T extends string>(props: Props<T>) => {
  return (
    <div css={[componentStyle, props.style]}>
      {props.items.map(item => (
        <RadioButtonSquare
          key={`${props.name}-${item.value}`}
          name={props.name}
          id={`${props.name}-${item.value}`}
          text={item.label}
          value={item.value}
          onChange={() => props.onChange(item.value)}
          checked={props.value === item.value}
          style={css([childComponentStyle, props.itemStyle])}
        />
      ))}
    </div>
  )
}

const componentStyle = css({
  display: 'flex',
  border: '1px solid #f5f5f5',
  padding: 1,
  borderRadius: 5,
  background: '#f5f5f5',
})

const childComponentStyle = css({
  label: {
    border: 'none',
    paddingBlock: 0,
    padding: 8,
  },
  input: {
    ':checked': {
      '+label': {
        border: '1px solid',
        background: '#fff',
      },
    },
  },
})
